import React from 'react'
import styled from 'styled-components'

import { PageList } from '../PageList'
import ToggleLanguage from '../ToggleLanguage'

interface PageCenterProps {}

const SCxContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
`

const PageCenter: React.FunctionComponent<PageCenterProps> = props => {
    return (
        <SCxContainer>
            <PageList />
            <ToggleLanguage />
        </SCxContainer>
    )
}

export default PageCenter
